import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import da_DK from './i18n/da_DK.json';
import en_US from './i18n/en_US.json';
import fr_FR from './i18n/fr_FR.json';
import de_DE from './i18n/de_DE.json';
import fi_FI from './i18n/fi_FI.json';
import nb_NO from './i18n/nb_NO.json';
import pl_PL from './i18n/pl_PL.json';
import sv_SE from './i18n/sv_SE.json';
import nl_NL from './i18n/nl_NL.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources wrapped under the default namespace 'translations'
    resources: {
      da_DK: { translations: da_DK },
      en_US: { translations: en_US },
      fr_FR: { translations: fr_FR },
      de_DE: { translations: de_DE },
      fi_FI: { translations: fi_FI },
      nb_NO: { translations: nb_NO },
      pl_PL: { translations: pl_PL },
      sv_SE: { translations: sv_SE },
      nl_NL: { translations: nl_NL },
    },
    fallbackLng: 'en_US',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    nsSeparator: ':', // keep namespace separator different from key separator
    // keySeparator left as default '.' for nested keys like 'auth.loginSuccess'
    interpolation: {
      escapeValue: false, // not needed for react
      formatSeparator: ',',
    },
    react: {
      useSuspense: true,
    },
  });
export default i18n;
